/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import {round, mapValues} from 'lodash';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {List, Map} from 'immutable';
import {DateTime} from 'src_common/utils/time/time';
import Loading from '../Loading';
import {BetSearchForm} from 'src/components/BetSearchForm/BetSearchForm';
import BetSearchResults from '../BetSearchResults';
import {Pagination} from 'src/components/Pagination/PaginationNew.tsx';
import { multipleBetTypes } from 'src/components/BetSearch/config.ts';
import {betTypesNotForAccumulatorPrice} from 'src/components/BetSearchResults/accumulator.ts';
import {generateCsv, mkConfig, download} from 'export-to-csv';
import {Amount} from 'src_common/common/amount/Amount';
import {formatAmountWithCurrency} from 'src_common/common/amount/website-money/currency';
import { cvsHeaderType } from 'src/components/BetSearch/betSearchCsv.config';

class BetSearch extends React.Component {
    static propTypes = {
        sports: ImmutablePropTypes.map,
        aggregations: ImmutablePropTypes.map,
        bets: ImmutablePropTypes.map,
        list: ImmutablePropTypes.list,
        state: PropTypes.string,
        perPage: PropTypes.number,
        page: PropTypes.number,
        bonusList: ImmutablePropTypes.list,
        isFetchingCompSports: PropTypes.bool,

        data: PropTypes.object,

        parameters: PropTypes.object,
        onQueryBetsRequest: PropTypes.func.isRequired,
        onQueryDataForCSV: PropTypes.func.isRequired,
        onUnmount: PropTypes.func,
        onGetBonusTypes: PropTypes.func.isRequired,
        getSports: PropTypes.func.isRequired,
    };

    static defaultProps = {
        sports: Map(),
        aggregations: Map(),
        bets: Map(),
        perPage: 20,
        page: 1,
        bonusList: List(),
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            data: {
                type: 'placement',
                range: {
                    startDate: DateTime.current().startOfDays().toISOString(),
                    endDate: DateTime.current().endOfDays().toISOString(),
                },
            },
            ...this.getState(props),
        };
    }

    UNSAFE_componentWillMount() {
        const {sports} = this.props;
        this.readRouterData();

        // Get list of all bonuses
        this.props.onGetBonusTypes();

        if (!sports.size) {
            this.props.getSports();
        }
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState(this.getState(props));
    }

    componentWillUnmount() {
        if (this.props.onUnmount) {
            this.props.onUnmount();
        }
    }

    getState(props) {
        return {
            sports: props.sports.toList(),
        };
    }

    readRouterData() {
        const {page, perPage} = this.props;
        let betsParameters;
        try {
            betsParameters = JSON.parse($appState.routerBackoffice.getParameter('global', 'bet.parameters'));
        } catch (e) {
            console.warn(e);
        }

        if (!betsParameters || Object.keys(betsParameters).length === 0) {
            return;
        }
        const {selection, type} = betsParameters;
        const betTypes =
            (selection) &&
            (type === 'single' ? ['SGL'] : multipleBetTypes).reduce((types, betType) => {
                types[`betType[${betType}]`] = true;
                return types;
            }, {});

        const data = {...this.state.data};
        delete data.range;

        this.data = {
            ...data,
            ...betsParameters,
            ...betTypes,
            selection,
            perPage,
            page,
        };
        this.props.onQueryBetsRequest(this.data);
    }

    onSubmit(data) {
        const {page, perPage} = this.props;
        this.data = {
            ...data,
            perPage,
            page,
        };
        this.props.onQueryBetsRequest(this.data);
    }

    onPageChange(page) {
        this.data.page = page;
        this.props.onQueryBetsRequest(this.data);
    }

    fetchDataForCSV = (queryData, prevData = []) => {
        queryData.perPage = 1000;
        queryData.page = queryData.page + 1;

        return this.props.onQueryDataForCSV(queryData).then((data) => {
            const newDataObject = [...prevData, ...data.results];

            if (data.results.length === queryData.perPage) {
                return this.fetchDataForCSV(queryData, newDataObject);
            }
            return newDataObject;
        });
    };

    uniq = (duplicatesArray) => {
        return [...new Set(duplicatesArray)];
    };

    getBetAccumulator = (bet) => {
        try {
            if (bet.type === null || bet.type === undefined) {
                return '';
            }

            if (betTypesNotForAccumulatorPrice.includes(bet.type)) {
                return '';
            }

            if (bet.legs.length === 1 || bet.type === 'SGL') {
                return '-';
            }
            return bet.legs
                .reduce((acc, curr) => {
                    if (curr.price === null) {
                        return acc;
                    }

                    const currentPriceIsDefined = curr.price.d !== null && curr.price.d !== undefined;

                    if (currentPriceIsDefined) {
                        return acc * curr.price.d;
                    }

                    return acc;
                }, 1)
                .toFixed(2);
        } catch (error) {
            console.info('bet', bet);
            console.error(error);
            return '';
        }
    };

    getBetPrice = (bet) => {
        if (bet.legs.length > 0) {
            const leg = bet.legs[0];

            if (leg !== undefined && leg.priceType === 'sp') {
                return leg.spPrice === null || leg.spPrice === undefined ? '' : leg.spPrice.f;
            } else {
                return leg.price === null || leg.price === undefined ? '' : leg.price.f;
            }
        }

        return '-';
    };

    getDecimalPrice = (bet) => {
        if (bet.legs.length > 0) {
            const leg = bet.legs[0];

            if (leg !== undefined && leg.priceType === 'sp') {
                return leg.spPrice === null || leg.spPrice === undefined ? '-' : round(leg.spPrice.d, 2);
            } else {
                return leg.price === null || leg.price === undefined ? '-' : round(leg.price.d, 2);
            }
        }

        return '-';
    };

    getBetStartingPrice = (bet) => {
        if (bet.legs.length > 0) {
            const leg = bet.legs[0];
            const racingSports = [
                'horseracing',
                'greyhoundracing',
                'internationalhorseracing'
            ];

            if (leg === undefined || bet.status !== 'settled' || !racingSports.includes(leg.sport.id)) {
                return '';
            } else {
                return round(leg.spPrice?.d, 2) ?? '';
            }
        }
    };

    createObjectForCsv = (data) => (
        data.map((bet) => {
            const mappedBet = mapValues(bet, (v) => (v === undefined || v === null || v === 0 ? '-' : v));

            const accumulator = this.getBetAccumulator(mappedBet);
            const price = this.getBetPrice(mappedBet);
            const decimalPrice = this.getDecimalPrice(mappedBet);
            const startingPrice =
                this.getBetStartingPrice(mappedBet) === undefined ? '' : this.getBetStartingPrice(mappedBet);

            return {
                betId: mappedBet.id,
                takenBy: bet.placedBy === undefined || bet.placedBy === null ? '-' : bet.placedBy.name,
                offeredBy: bet.offeredBy === undefined || bet.offeredBy === null ? '-' : bet.offeredBy.name,
                accountId: mappedBet.account.id,
                name: mappedBet.account.name,
                placementDate:
                    mappedBet.placedAt === '-'
                        ? '-'
                        : new Date(mappedBet.placedAt).toLocaleDateString('en-GB', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit',
                        }),
                settledDate:
                    mappedBet.settledAt === '-'
                        ? '-'
                        : new Date(mappedBet.settledAt).toLocaleDateString('en-GB', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit',
                        }),
                sf: mappedBet.stakeFactor,
                inPlay: mappedBet.legs.reduce((value, next) => value && next.inPlay, true) ? 'Y' : 'N',
                sport:
                    this.uniq(mappedBet.legs.map((leg) => leg.sport && leg.sport.name))
                        .filter(x => x)
                        .join(', ') || '-',
                competition:
                    this.uniq(mappedBet.legs.map((leg) => leg.competition && leg.competition.name))
                        .filter(x => x)
                        .join(', ') || '-',
                event: this.uniq(mappedBet.legs.map((leg) => leg.event.name)).join(', '),
                market:
                    this.uniq(
                        mappedBet.legs.map((leg) => {
                            if (leg.type === 'rab' || leg.type === 'betBuilder') {
                                const selectionArray = [];

                                mappedBet.legs[0].selections.map((selection) => {
                                    const value = selection?.market?.name || leg?.market?.type;

                                    if (value) {
                                        selectionArray.push(value);
                                    }
                                });

                                return this.uniq(selectionArray);
                            } else {
                                const marketsMap = mappedBet.legs.map(leg => {
                                    if (leg?.market) {
                                        return (leg.market.name) || leg.market.type;
                                    }
                                });

                                return this.uniq(marketsMap);
                            }
                        })
                    )
                    .filter(x => x)
                    .join(', ') || '-',

                selection:
                    this.uniq(
                        mappedBet.legs.map((leg) => {
                            if (leg.type === 'rab' || leg.type === 'betBuilder') {
                                const selectionArray = [];

                                mappedBet.legs[0].selections?.map((selection) => {
                                    const name = selection?.selection?.name;
                                    if (name) {
                                        selectionArray.push(name);
                                    }
                                });

                                return selectionArray.join(', ');
                            } else {
                                return leg?.selection?.name;
                            }
                        })
                    )
                    .filter(x => x)
                    .join(', ') || '-',
                price,
                decimalPrice,
                accumulator,
                priceType: mappedBet.legs.length ? mappedBet.legs[0].priceType.toUpperCase() : '-',
                startingPrice,
                ew: mappedBet.eachWay !== '-' && (mappedBet.eachWay ? 'Y' : 'N'),
                ewTerms: this.generateEWTerms(mappedBet.legs[0].eachWayTerms),
                betType: mappedBet.type,
                stakePerLine:
                    mappedBet.stakePerLine === '-'
                        ? '-'
                        : $appState.configState.precision.newFromOld(mappedBet.stakePerLine).value,
                totalStake:
                    mappedBet.totalStake === '-'
                        ? '-'
                        : $appState.configState.precision.newFromOld(mappedBet.totalStake).value,
                results: mappedBet.cashOut
                    ? 'Cashed Out'
                    : (mappedBet.legs[0].result?.type) || '-',
                payout:
                    mappedBet.payout === '-' ? 0 : $appState.configState.precision.newFromOld(mappedBet.payout).value,
                maxLineSteak:
                    mappedBet.maxBet === '-' ? '-' : $appState.configState.precision.newFromOld(mappedBet.maxBet).value,
                stakePerLineByMaxAllowedBet:
                    mappedBet.maxBet === '-'
                        ? '-'
                        : `${$appState.configState.precision
                            .newFromOld(mappedBet.stakePerLine)
                            .div(mappedBet.maxBet)
                            .toFixed(2)}%`,
                channel: mappedBet.channel,
                status: mappedBet.status,
                affiliate: mappedBet.affiliate,
                comment: mappedBet.comment,
                ipAddress: mappedBet.ip,
            };
        })
    );

    onGenerateCSV = (clearAfterGenerate) => {
        const options = {
            quoteStrings: true,
            title: 'Bet-search',
            filename: 'Bet-search Raport',
            columnHeaders: cvsHeaderType,
        };

        const csvExporter = mkConfig(options);
        const requestParams = {...this.data, page: 0};
        const savedPage = {page: this.data.page, perPage: this.data.perPage};

        this.fetchDataForCSV(requestParams).then((data) => {
            const possibleAnswers = this.createObjectForCsv(data);
            const csv = generateCsv(csvExporter)(possibleAnswers);

            download(csvExporter)(csv);

            clearAfterGenerate();

            this.data.page = savedPage.page;
            this.data.perPage = savedPage.perPage;
        });
    };


    generateEWTerms = (eachWayTerms) => {
        if (eachWayTerms) {
            const reduction = eachWayTerms.reduction;
            if (typeof reduction === 'string') {
                return `${reduction} for ${eachWayTerms.places} place`;
            }

            const den = reduction?.den ? reduction.den : '';
            const num = reduction?.num ? reduction.num : '';

            return `${num}/${den} for ${eachWayTerms.places} place`;
        }
        return '';
    };

    onBack(e) {
        e.preventDefault();

        if (this.props.onUnmount) {
            this.props.onUnmount();
        }
    }

    render() {
        const {sports, state, bets, list, aggregations, page, perPage, bonusList, isFetchingCompSports} = this.props;
        const {data, sports: sportsList} = this.state;
        const currency = 'GBP';
        const isSpColumn = data.startingPrice;

        let summary;
        if (aggregations.size) {
            summary = (
                <ul className='bet-search-summary' data-test='bet-search-summary'>
                    <li data-test='total-no-of-bets'>
                        <strong data-test='total-no-of-bets-text'>Total no. of{`${data.freebet ? ' free' : ''}`} bets:</strong>{' '}
                        {aggregations.get('total')}
                    </li>
                    {aggregations.get('totalStake') ? (
                        <li data-test='total-stakes'>
                            <strong data-test='total-stakes-text'>Total{`${data.freebet ? ' free bet' : ''}`} stakes:</strong>{' '}
                            {formatAmountWithCurrency(currency, new Amount(aggregations.get('totalStake')))}
                        </li>
                    ) : null}
                    {aggregations.get('averageStake') ? (
                        <li data-test='average-stakes'>
                            <strong data-test='average-stakes-text'>Average {`${data.freebet ? ' free bet' : ''}`} stakes:</strong>{' '}
                            {formatAmountWithCurrency(currency, new Amount(aggregations.get('averageStake')))}
                        </li>
                    ) : null}
                    {aggregations.get('totalProfitLoss') ? (
                        <li data-test='total-profit-loss'>
                            <strong data-test='total-profit-loss-text'>Total {`${data.freebet ? ' free bet' : ''}`} P/L:</strong>{' '}
                            {formatAmountWithCurrency(
                                currency,
                                new Amount(`${aggregations.get('totalProfitLoss')}`).inverse()
                            )}
                        </li>
                    ) : null}
                </ul>
            );
        }

        const loadingEl = (
            <Loading
                message='Loading bets...'
                active={state === 'IN_PROGRESS'}
            />
        );

        if (list) {
            return (
                <div>
                    {loadingEl}
                    {summary}
                    <a
                        href='#'
                        className='bet-search-close'
                        onClick={this.onBack.bind(this)}
                    >
                        Back to search criteria &times;
                    </a>
                    <BetSearchResults
                        sports={sports}
                        bets={bets}
                        list={list}
                        bonusList={bonusList}
                        summary={!summary}
                        isSpColumn={isSpColumn}
                    />
                    <Pagination
                        className='bet-search__pagination'
                        perPage={perPage}
                        page={page}
                        total={aggregations.get('totalWithXTS') ?? aggregations.get('total')}
                        currentVisibleItems={list.size}
                        onPageChange={this.onPageChange.bind(this)}
                        onGenerateCSV={this.onGenerateCSV}
                    />
                </div>
            );
        }

        return (
            <div>
                {loadingEl}
                <BetSearchForm
                    data={data}
                    sports={sportsList}
                    disabled={state === 'IN_PROGRESS'}
                    isFetchingCompSports={isFetchingCompSports}
                    onSubmit={this.onSubmit.bind(this)}
                    bonusList={bonusList}
                />
            </div>
        );
    }
}

export default BetSearch;
